//import libraries
import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppPermissions } from '../../../../constants/app-permission';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { AuthService } from '../../../../services/auth.service';
import { GeneralService } from '../../../../services/general.service';
import { NotificationService } from '../../../../services/notification.service';
import { ConsultancyService } from '../../../../services/consultancy.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
declare var $: any;

@Component({
  selector: 'app-consultancy_event_create',
  templateUrl: './consultancy-event-create.component.html',
  styleUrls: ['./consultancy-event-create.component.css']
})
export class CreateConsultancyEventComponent implements OnInit {
  @Input() langs;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  lang: any;
  id: any;
  contract_type: any;
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    public bsModalRef: BsModalRef,
    private notificationService: NotificationService,
    private consultancyService: ConsultancyService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.FormBuild()
    this.createFormErrorMsg = {
      'date_event': [{ type: 'required', message: this.langs.requiredField }],
      'title_event': [{ type: 'required', message: this.langs.requiredField }],
      'des_event': [{ type: 'required', message: this.langs.requiredField }],
    }
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      date_event:  ['', [Validators.required]],
      title_event: ['', [Validators.required]],
      des_event: ['', [Validators.required]],
      submit: 'update',
    });
  }

  onSubmit() {
    
    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

      this.passEntry.emit(this.createForm.value);
      this.bsModalRef.hide()

  }

}
